export const BID_TYPES = {
  USER_BID: 1,
  BID_ON_AGENT: 4,
}
